import { render, staticRenderFns } from "./Limited.vue?vue&type=template&id=60ea0c68"
import script from "./Limited.vue?vue&type=script&lang=js"
export * from "./Limited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60ea0c68')) {
      api.createRecord('60ea0c68', component.options)
    } else {
      api.reload('60ea0c68', component.options)
    }
    module.hot.accept("./Limited.vue?vue&type=template&id=60ea0c68", function () {
      api.rerender('60ea0c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/PageHeader/Limited.vue"
export default component.exports